module.exports = __webpack_public_path__ + "img/guest-user-logo-large.71f4e5ba.png";